import { Moon, Sun, Laptop } from 'lucide-react';
import { useTheme } from './ThemeProvider';
import { Button } from './ui/Button';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { cn } from '@/lib/utils';

export function ThemeToggle() {
  const { theme, resolved, setTheme } = useTheme();
  const Icon = resolved === 'dark' ? Moon : Sun;

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <Button variant="ghost" size="icon" aria-label="Toggle theme">
          <Icon className="h-4 w-4" />
        </Button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content
          align="end"
          className="z-50 min-w-[10rem] rounded-md border bg-card p-1 text-card-foreground shadow-md"
        >
          {(['light', 'dark', 'system'] as const).map((t) => {
            const IconT = t === 'light' ? Sun : t === 'dark' ? Moon : Laptop;
            return (
              <DropdownMenu.Item
                key={t}
                onSelect={() => setTheme(t)}
                className={cn(
                  'flex cursor-pointer items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-none',
                  'focus:bg-accent focus:text-accent-foreground',
                  theme === t && 'font-medium text-primary',
                )}
              >
                <IconT className="h-3.5 w-3.5" />
                <span className="capitalize">{t}</span>
              </DropdownMenu.Item>
            );
          })}
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}
